var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPgk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2754_3456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2754_3456)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#E11C1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L23 23H0V0Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09119 17.5072H6.04843L6.50368 16.0762L7.03878 17.4976L8.01953 17.5691L7.18137 18.7855L7.61173 20.2508L6.54635 19.4351L5.56253 20.2581L5.93365 18.8354L5.09119 17.5072Z",
    fill: "#EEEEF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.21619 13.6737H3.17343L3.62868 12.2427L4.16378 13.6641L5.14453 13.7356L4.30637 14.952L4.73673 16.4173L3.67135 15.6016L2.68753 16.4246L3.05865 15.0019L2.21619 13.6737Z",
    fill: "#EEEEF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.09119 11.7572H6.04843L6.50368 10.3262L7.03878 11.7476L8.01953 11.8191L7.18137 13.0355L7.61173 14.5008L6.54635 13.6851L5.56253 14.5081L5.93365 13.0854L5.09119 11.7572Z",
    fill: "#EEEEF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.97992 15.874L7.63792 15.8448L7.87544 14.9399L8.14211 15.84L8.74758 15.9176L8.20235 16.4316L8.64209 17.3418L7.87917 16.9613L7.21795 17.354L7.56713 16.4566L6.97992 15.874Z",
    fill: "#EEEEF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41742 13.957L9.07542 13.9278L9.31294 13.0229L9.57961 13.923L10.1851 14.0006L9.63985 14.5146L10.0796 15.4248L9.31667 15.0443L8.65545 15.437L9.00463 14.5396L8.41742 13.957Z",
    fill: "#EEEEF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1541 1.9165C15.1541 1.9165 12.934 2.50703 13.5571 6.62177H13.2403C13.2403 6.62177 13.2662 6.40706 12.9617 6.28117C12.6572 6.15527 12.7182 6.20253 12.5611 6.28117C12.4039 6.3598 11.4479 6.28117 11.4479 6.28117V6.43868L12.1244 6.82826C12.1244 6.82826 12.1077 7.15265 12.3906 7.3324C12.6734 7.51216 12.8788 7.59878 12.8788 7.59878C12.8788 7.59878 12.9206 7.95674 12.6556 7.95674C12.3906 7.95674 11.3246 7.49603 10.9455 8.62793C10.5664 9.75984 10.0625 10.5903 10.0625 10.5903H10.631L10.4784 10.8431H11.1185L10.9455 10.974C10.9455 10.974 11.7374 10.9623 11.7991 10.8431C11.8609 10.7239 11.7991 11.1663 11.7991 11.1663C11.7991 11.1663 12.5662 10.6992 12.6083 10.5903L12.9663 10.9178L13.0683 10.3636L13.4525 10.5903L13.5571 10.0623C13.5571 10.0623 14.6439 12.4858 15.4682 12.3467V11.9445L16.2204 12.3467L16.3159 12.1678C16.3159 12.1678 17.2246 12.6618 17.5043 12.7076L17.3047 12.1678H17.5043L17.3047 11.1663H17.5043L17.1052 10.3636L17.217 10.1463L17.143 9.86072C17.143 9.86072 18.606 10.4821 18.5401 11.4708C18.4741 12.4594 17.8225 12.8584 17.8225 12.8584C17.8225 12.8584 17.1977 13.1136 16.6333 13.0587C16.6333 13.0587 17.0813 13.7643 18.0292 13.5252C18.9771 13.2861 19.2913 12.0606 19.2913 12.0606C19.2913 12.0606 19.7259 13.2643 19.3681 13.8972C19.0103 14.5301 17.4172 14.9745 17.4172 14.9745C17.4172 14.9745 17.9936 15.4251 18.5401 15.3096C19.0866 15.1942 19.9364 14.56 20.1012 13.5252C20.266 12.4904 19.5328 10.581 19.2007 10.3636L19.0695 9.70117L19.3681 9.86072L18.7554 7.86311L19.0525 7.9499L18.1857 6.51226L18.4244 6.41423L17.2269 5.26651L17.5852 5.14029C17.5852 5.14029 16.7001 4.54219 15.6904 5.26651L15.6999 5.01627L15.4346 5.07608L15.4503 4.80083L15.714 4.26808L15.3181 4.06469C15.3181 4.06469 15.6382 3.42365 15.5901 3.43245C15.5901 3.43245 15.2334 3.56894 15.2537 3.51174C15.2537 3.51174 15.4336 2.89392 15.3863 2.91046C15.3863 2.91046 14.9726 3.09804 15.0338 3.00417L15.1928 2.62673L15.1541 1.9165Z",
    fill: "#FBCD17"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2754_3456)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2754_3456",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPgk);
export default __webpack_public_path__ + "static/media/PGK.36d758a8ca71d95c972139706d513540.svg";
export { ForwardRef as ReactComponent };